export const convertToUrl = function (p) {
	var name =  p.name.split(' ').join('_');
	var color = p.color_name.split(' ').join('_');
	var color2 = p.color2_name;

	var url = name + `-${ color }`;

	if (color2) {
		color2 = color2.split(' ').join('_');
		url += `-${ color2 }`;
	}

	return url.toLowerCase();
}


// WEBPACK FOOTER //
// ./src/scripts/convert_name.js